/// <amd-module name="TFS/Samples/DatePicker/DatePicker" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";

import { DatePicker } from "VSSUI/DatePicker";

interface DatePickerProps {}

export class DatePickerPage extends VssComponent<DatePickerProps> {
    private date: ObservableValue<Date> = new ObservableValue(new Date());
    constructor(props: DatePickerProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div>
                <Observer date={this.date}>
                    {(props: { date?: Date }) => {
                        return <DatePicker ariaLabel="Aria label" value={props.date} onChange={this.onChange} errorMessage="Error message" />;
                    }}
                </Observer>
            </div>
        );
    }

    private onChange = (date: Date) => {
        this.date.value = date;
    };
}

Components.add("date-picker-page", DatePickerPage);
